import React from 'react';
import { Classable, HasChildren } from '@shapeable/types';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { PageContextDefinition, useEmbedComponents, LayoutShell, SiteFooterLayout, UiConfig, UiProvider } from '@shapeable/ui';

import * as pageLayouts from './page-layouts';
import * as sliceLayouts from './slice-layouts';
import { LANG_STRINGS } from '../lang';
import { LayoutStyles, MARINE_GREEN, themeOverrides } from '../theme';
// import { SiteHeaderLayout } from '../entities/site-header-layout';

export type LayoutPropTypes = Classable & HasChildren & {
  path?: string;
  data?: any;
  pageContext?: PageContextDefinition;
};

const LayoutDefaultProps: LayoutPropTypes = {
};

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
    ${LayoutStyles};
  `,
});

const FooterStyles = breakpoints({
  base: css`
  `,
});

const BodyStyles = breakpoints({
  base: css`
    flex-grow: 1;
  `,
});

// -------- Components -------->

const My = {
  Container: styled(LayoutShell)`${ContainerStyles}`,
  Body: styled.div`${BodyStyles}`,
  Footer: styled(SiteFooterLayout)`${FooterStyles}`,
};

export const Layout: React.FC<LayoutPropTypes> = (props) => {
  const { className, children } = props;

  const embedComponents = useEmbedComponents();
  
  const config: UiConfig = {
    layouts: { pageLayouts, sliceLayouts, defaultPageLayout: pageLayouts.PageLayoutDefault },
    langStrings: LANG_STRINGS,
    theme: themeOverrides,
    header: {
      // showThemeMode: true,
      variant: 'default',
    },
    componentProps: {
      SiteHeaderLayout: {
        colors: {
          background: 'light',
        },
      },
      SiteMenuBar: {
        colors: {
          background: 'light',
          text: 'dark',
          dark: {
            background: 'dark',
            text: 'light',
          }
        },
        
      },
      NavigationMenuItem: {
        colors: {
          background: '#1E1E1E',
          text: 'light',
          hover: {
            text: 'light',
            background: MARINE_GREEN,
          },
          active: {
            background: '#1E1E1E',
          }
        }
      },
      MenuItemLink: {
        colors: {
          hover: {
            text: MARINE_GREEN,
            fill: MARINE_GREEN,
            border: MARINE_GREEN,
          },
          active: {
            text: MARINE_GREEN,
            fill: MARINE_GREEN,
            border: MARINE_GREEN,
          }
        }
      },
      MenuItem: {
        colors: {
          text: 'light',
          hover: {
            text: 'light',
            background: MARINE_GREEN,
          },
          
        }
      }
    },
  }


  return (
    <UiProvider value={config}>
      <My.Container
        className={className}
        includeTooltip
        tooltipProps={{
          backgroundColor: '#FFFFFF',
        }}
      >
        <My.Body>
          {children}
        </My.Body>
        <My.Footer backgroundColor='canvas' />
      </My.Container>
    </UiProvider>
  );
  
  
};

Layout.defaultProps = LayoutDefaultProps;

